/* istanbul ignore file */

import { isBrowser } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { NextConfig } from './types/nextConfig';

const { publicRuntimeConfig } = getConfig() as NextConfig;

const {
  PARTNER_APPLICATIONS_CLOSED,
  PARTNERMGT_ONBOARDING_API_ENDPOINT,
  UPLOAD_SECTIONS_ENABLED,
  monitoring,
} = publicRuntimeConfig;

export const NODE_ENV = publicRuntimeConfig.NODE_ENV || 'development';
export const ENV_TYPE = publicRuntimeConfig.ENV_TYPE || 'development';
export const IN_TEST = NODE_ENV === 'test';
export const IN_DEV = ENV_TYPE === 'development';
export const IN_PROD = ENV_TYPE === 'production';
export const IS_CLIENT = isBrowser();
export const serviceName = monitoring.serviceName;

// Log in as the QA admin user in development so that an ID token exists in Localstorage
// to send to the onboarding api via `x-id-token`
export const shouldSignInAsQAAdmin = () => IS_CLIENT && IN_DEV;

export const API_ENDPOINT = PARTNERMGT_ONBOARDING_API_ENDPOINT;
export const API_TIMEOUT = 60 * 1000;

export const getFeatureFlags = () => ({
  signUpEnabled: !PARTNER_APPLICATIONS_CLOSED,
  uploadSectionsEnabled: UPLOAD_SECTIONS_ENABLED,
});

export const isDevToolsEnabled = () => {
  if (IN_PROD) {
    return false;
  }

  if (IS_CLIENT) {
    const value = window.localStorage.getItem('devTools');
    return value !== null ? JSON.parse(value) : IN_DEV;
  }

  return false;
};
